module.exports = __webpack_public_path__ + "img/g_yanzhong.2958d01c.png";